import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Inline } from 'trellis-components/components/layout/Inline';
import { Stack } from 'trellis-components/components/layout/Stack';
import { Spinner } from 'trellis-components/components/Spinner';
import { useUiVariant } from './UiVariantProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TrellisLoadingSpinner = ({
  label,
  layout,
  showLabel = false,
  size
}) => {
  const spinner = /*#__PURE__*/_jsx(Spinner, {
    size: size === 'xs' || size === 'extra-small' ? 16 : 20
  });
  if (showLabel && label != null) {
    return /*#__PURE__*/_jsxs(Inline, {
      verticalAlign: "center",
      children: [spinner, label]
    });
  }
  if (layout === 'centered') {
    return /*#__PURE__*/_jsx(Stack, {
      align: "center",
      children: spinner
    });
  }
  return spinner;
};
export const CdpLoadingSpinner = props => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisLoadingSpinner, Object.assign({}, props)) : /*#__PURE__*/_jsx(LoadingSpinner, Object.assign({}, props));
};